//import * as json2csv from 'json2csv';
import { Injectable,ViewChild } from '@angular/core';
import { Location, CurrencyPipe } from '@angular/common';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

import { BackendService } from './backend.service';
import { AuthService } from './auth.service';
import { NotificationService } from '../notification/notification.service';
import { SearchService } from './search.service';
import { OrderByService } from './orderby.service';
import { Utilities } from './utilities.service';
import { PaginationService } from './pagination.service';
import { FilterService } from './filter.service';
import { Subscription } from 'rxjs/Subscription';
//import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { map, filter, switchMap } from 'rxjs/operators';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';
import { MatInput } from '@angular/material/input';
import CONFIG from 'config';
@Injectable()
export class MultiColumnGridService extends Utilities 
{
    currency:any;
    exportDataOrder:any;
    currentPage: string = '';
    loadingData: boolean = false;
    pagenlenth: boolean = true;
    items: Object[] = [];
    originalItems: Object[] = [];
    filteredBySettlementAccount: Object[] = [];
    filteredByCurrency: Object[] = [];
    filteredBySAandC: Object[] = [];
    audit: Object[] = [];
    searchFilteredItems: Object[] = [];
    exportItems: Object[] = [];
    prefilteredItems: Object[] = []; //dropdown/checkbox filtered
    totalEntries: number = 0;
    dataCallback: Function;
    filterApplied: boolean = false;
    FilterByStatus: FormGroup;
    statusSubscription: Subscription;
    settlementAccount: FormGroup;
    accountNo: FormControl;
    TextSearch: FormGroup;
    term: FormControl;
    allSubscription: Subscription;
    selected;
    active: string = '';
    entryRange: Array<number>;
    entryRangeSubscription: Subscription;
    apiUrl: string = '';
    searchArray: Array<string> = [];
    accountsArray: Array<string> = [];
    securityArray: Array<string> = [];
    submitted: boolean = false;
    fields: string[] = [];
    fieldNames: string[] = [];
    defaultSortOrder: string = '';
    currentSortOrder: string = '';
    exportTitle: string = 'Exported-Data';
    // audit: any;
    checkbox: any;
    
    exchangerate: any;
    consolidate:any;
    echangereatecalculated:any;
    accuredintrest: any;
    repocurrency: any;
    accuredintrestcalculated: any;
    noEntrys: boolean = false;
    sortingpageload:any;
    openAccount:boolean;
    datefilteredaudit: Object[] = [];
    RadioSearch: FormGroup;
    RadioFilter: FormControl;
@ViewChild('fromInput', {
        read: MatInput
      }) fromInput: MatInput;
      
      @ViewChild('toInput', {
        read: MatInput
      }) toInput: MatInput;
    constructor(
        public location: Location,
        public backendService: BackendService,
        public authService: AuthService,
        public notificationService: NotificationService,
        public formBuilder: FormBuilder,
        public searchService: SearchService,
        public orderByService: OrderByService,
        public router: Router,
        public paginationService: PaginationService,
        public currencyPipe: CurrencyPipe,
        public filterService: FilterService
    ) {
        super(location, notificationService, authService, backendService);
    }

    serviceInit(dataCallback?: Function, filterInit = true) {

        // this.RadioFilter = new FormControl();
        // this.RadioSearch = new FormGroup({
        //     RadioFilter:  this.RadioFilter
        // });
        // this.FilterByStatus = this.formBuilder.group({
        //     'account_name': []
        // });
        this.term = new FormControl();
        this.TextSearch = new FormGroup({
            term: this.term,
          
        });
        this.accountNo = new FormControl();
        this.settlementAccount = new FormGroup({
            accountNo: this.accountNo
        });

        this.getData();

        //if dataCallback is passed, give it the data and return- 
        //used if we need to do some extra formatting for a component
        if (dataCallback) { this.dataCallback = dataCallback; }

        //filter by dropdown/checkbox section- handle subscription (form configured in child component)
        //only if child component calls it (some don't have this feature)
        if (filterInit) {

        }
       

        //subscription to update page numbering and currently showing array- uses pagination service
        this.entryRangeSubscription = this.paginationService.entryRange
            .subscribe(range => {
                this.entryRange = range;
                // console.log("range" + this.entryRange[0], this.entryRange[1]);
                if (!this.term.value) {
                    if (this.audit.length == 0) {
                        this.audit = this.originalItems;
                       // console.log("initial dates");
                    }

                    this.audit = this.originalItems.slice(this.entryRange[0], this.entryRange[1]);
                    this.totalEntries = this.originalItems.length;
                } else {

                    this.audit = this.searchFilteredItems.slice(this.entryRange[0], this.entryRange[1]);
                    this.totalEntries = this.searchFilteredItems.length;
                }

            });

    }

 clearDateFilter() {
       
        this.fromInput.value = '';
        this.toInput.value = '';
        this.audit = this.originalItems;
       // console.log("clear date filter");
        this.totalEntries = this.audit.length;
         this.loadingData = true;
                this.pagenlenth = false;
                this.setGrid(1, this.audit.length, "search");
                this.entryRangeSubscription = this.paginationService.entryRange
                    .subscribe(range => {
                        this.entryRange = range;
                        // console.log("range" + this.entryRange[0], this.entryRange[1]);
                        if (!this.term.value) {
                            // if (this.audit.length == 0) {
                            //     this.audit = this.filteredBySettlementAccount;
                            // }
                            this.audit = this.filteredBySettlementAccount.slice(this.entryRange[0], this.entryRange[1]);
                            this.exportItems=this.filteredBySettlementAccount;
                            this.totalEntries = this.filteredBySettlementAccount.length;
                        } else {
                            this.audit = this.searchFilteredItems.slice(this.entryRange[0], this.entryRange[1]);
                            this.exportItems=this.searchFilteredItems;
                            this.totalEntries = this.searchFilteredItems.length;
                        }
                    });
    }
    clearSearch() {
        //  this.term.setValue('');
        this.audit = this.originalItems;
        this.searchFilteredItems = [];
    }
    clearTextSearch() {
        this.term.setValue('');
        this.audit = this.originalItems;
        this.searchFilteredItems = [];
        this.setGrid(1, this.audit.length);
    }


    getData() {
        this.sortingpageload="pageload";
     //   console.log('getdata');
        //if we have a text search enabled and delete an item, the grid won't filter properly, so reset search first
        this.clearSearch();
        // console.log("available " + this.authService.CustomerID);
       // console.log(this.apiUrl);
        this.backendService.getData(`${this.apiUrl}/${this.authService.CustomerID}`)
            .subscribe(data => {
                //.subscribe((response: any) => {

                //all items- only changes here
                //   this.originalItems = response.map(item => item);
                if (data['myCustomer'] != null) {
                    // return new Promise(
                    //     function (resolve, reject) {
                    //         let lowerItem = typeof item === 'string' ? item.toLowerCase() : item;
                    //         let filtered: Array<Object> = [];

                    //         filtered = group.filter(g => {
                    //             if (g[property]) {
                    //                 let lowerProp = g[property].toLowerCase();

                    //                 //search group (by property provided) for substring item
                    //                 if (lowerProp.search(lowerItem) !== -1) return g[property];
                    //             }
                    //         });

                    //         resolve(filtered);
                    //     }
                    // );
                   
                    this.originalItems = data['myCustomer'];
                    this.exportDataOrder=data['myCustomer'];
                    //this.currency=data['currency'];
                    //console.log(data['currency']);
                    //console.log(this.originalItems );
                    //console.log(this.currency);

                }
                //   if (data['exchagerate'] != null) {
                //       this.exchangerate=data['exchagerate'];
                //      console.log(this.exchangerate);
                     
                //   }
                //   if (data['data'] != null) {
                //       this.accuredintrest=data['data'];
                    
                //   }
                //   if(data['currency'] != null)
                //   {
                //       this.repocurrency=data['currency'];
                //       console.log(data['currency'],this.repocurrency);
                //   }


                if (this.dataCallback) {
                    this.dataCallback(this.originalItems);
                }

               this.searchFilteredItems = this.originalItems;


              
                //full list for pagination, and list for each page
                this.audit = this.originalItems;

                if(this.currentPage=='positions'){
                   // this.filteredBySettlementAccount = this.originalItems;
                     this.setGrid(1, this.totalEntries, "Getdata");
                        this.orderBy(this.defaultSortOrder);
                     }
                // this.filteredBySettlementAccount = this.originalItems;
                if(this.currentPage=='actitvity'){
                    this.filteredBySettlementAccount = this.originalItems;
                     this.setGrid(1, this.totalEntries, "Getdata");
                        this.orderBy(this.defaultSortOrder);
                     }


                this.totalEntries = this.audit.length;
                if (this.audit.length === 0) {
                    this.noEntrys = true;
                }
                // this.setGrid(1, this.totalEntries, "Getdata");
                // this.orderBy(this.defaultSortOrder);
                this.loadingDataStatus(true);
            },
            error => {
                this.serverErrorOrTimeout(error);
            });
    }

   orderBy(param, length?: number) {
      //  console.log('order by ' + param);
        if (param!==''){
            this.currentSortOrder = param;
        } else {
            param = this.defaultSortOrder;
        };
       // console.log(param);
       // console.log(this.currentSortOrder);
      // console.log(this.filteredBySAandC);
        if (this.filteredBySAandC.length > 1) {
            var itemsToOrder = this.filteredBySAandC;
        }
        //  else if (this.filteredByCurrency.length > 1) {
        //     var itemsToOrder = this.filteredByCurrency;
        // } else if (this.filteredByCurrency.length === 0) {
        //     var itemsToOrder = this.filteredBySettlementAccount;
        // } 
        else {
            var itemsToOrder = this.originalItems;
        };
        // let itemsToOrder = this.filteredBySettlementAccount;
        let sortingByCurrentShares = false;
        const altParam = param === this.defaultSortOrder ? undefined : this.defaultSortOrder;

        if (this.term.value) {
            itemsToOrder = this.searchFilteredItems;
        }

        //special case for currentShares- strip commas so orders correctly
        // if (param === 'currentShares') {
        //     // console.log('ordering by current shares!');
        //     sortingByCurrentShares = true;
        //     itemsToOrder.forEach(item => {
        //         item['currentShares'] = item['currentShares'].replace(/,/gi, '');
        //     });
        // }
        if(this.sortingpageload!="pageload")
         {
         //console.log(param, itemsToOrder, altParam, this.currentPage)
       this.items = this.orderByService.orderByParam(param, itemsToOrder, altParam, this.currentPage);
            }
        else{ 
            this.items = this.orderByService.orderByParamdes(param, itemsToOrder, altParam,this.currentPage);

          }
       // console.log(this.items);


        //re-format the currentShares to display as currency
        // if (sortingByCurrentShares) {
        //     this.items.forEach(item => {
        //         item['currentShares'] = this.currencyPipe
        //             .transform(item['currentShares'], 'USD', false, '4.2-2')
        //             .slice(3);
        //     });
        // }
        if (length){
            var itemsLength: number = length;
        } else {
            var itemsLength: number = itemsToOrder.length;
        }

        this.setGrid(1, itemsLength, "orderby");
        // this.loadingDataStatus(true);

    }
    exportData(submittedData?: Object[], name?: string, heading?: string) 
    {

        var options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            showTitle: true,
            title: heading,
            useBom: true,
            //noDownload: true,
            headers: this.fieldNames,
            nullToEmptyString: true,
        };
        
        const data = submittedData;
      //  console.log(data);
        new Angular5Csv(data, name, options);

    }

    

    setGrid(start: number, length?: number, value?: string) {
      //  console.log(start,length);
        const sentLen = length;
        this.pagenlenth = false;

        this.paginationService.setGrid(start, sentLen);
    }
    // Observable string sources
    private loadingDataChangeConfirmedSource = new Subject<string>();

    // Observable string streams
    loadingDataChange$ = this.loadingDataChangeConfirmedSource.asObservable();

    loadingDataStatus(loadingData: boolean) {

        // console.log(loadingData);
        if (!this.loadingData) {
            this.loadingData = loadingData;
            this.loadingDataChangeConfirmedSource.next('loadingData');
        } else {
            return;
        }
    }

    //makes table rows expandable in mobile screensize
    makeActive(item) {
        this.active = this.active === item ? '' : item;
    }
}